// Helper function to load saved settings from localStorage
const loadSavedSettings = () => {
  const savedSettings = localStorage.getItem('layoutSettings')
  console.log("savedSettings", savedSettings);
  return savedSettings ? JSON.parse(savedSettings) : {}
}

// Initial state with default values, overridden by saved settings if available
const savedSettings = loadSavedSettings()

export const state = {
  layoutWidth: savedSettings.layoutWidth || 'fluid',
  leftSidebarType: savedSettings.leftSidebarType || 'light',
  loader: false,
  mode: savedSettings.mode || "light",
  language: savedSettings.language || 'he',
  direction: savedSettings.direction || 'rtl'
}

// Helper function to save current state to localStorage
const saveSettings = (state) => {
  const settings = {
    layoutWidth: state.layoutWidth,
    leftSidebarType: state.leftSidebarType,
    mode: state.mode,
    language: state.language,
    direction: state.direction
  }
  localStorage.setItem('layoutSettings', JSON.stringify(settings))
}

export const getters = {}

export const mutations = {
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
    saveSettings(state);
  },
  CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType;
    saveSettings(state);
  },
  LOADER(state, loader) {
    state.loader = loader
  },
  CHANGE_MODE(state, mode) {
    state.mode = mode;
    saveSettings(state);
  },
  SET_LANGUAGE(state, language) {
    state.language = language;
    saveSettings(state);
  },
  SET_DIRECTION(state, direction) {
    console.log("SET_DIRECTION", direction);
    state.direction = direction;
    document.getElementsByTagName("html")[0].setAttribute("dir", direction);
    saveSettings(state);
  }
}

export const actions = {
  // Initialize layout settings from localStorage (can be called when app starts)
  initializeLayout({ commit, state }, { i18n } = {}) {
    
    // Apply saved language if it exists and i18n is provided
    if (state.language && i18n) {
      try {
        // Check what type of i18n API we're dealing with
        if (i18n.global && typeof i18n.global.locale === 'object') {
          i18n.global.locale.value = state.language;
        } else if (i18n.global) {
          i18n.global.locale = state.language;
        } else {
          i18n.locale = state.language;
        }
      } catch (error) {
        console.error("Error setting i18n locale:", error);
        // Fallback method for older Vue I18n versions
        try {
          i18n.locale = state.language;
        } catch (fallbackError) {
          console.error("Fallback method also failed:", fallbackError);
        }
      }
    }

    if (state.language && state.language !== i18n.global.locale) {
      console.log("setting i18n.global.locale.value", state.language);
      i18n.global.locale = state.language;
    }

    // RTL languages: Hebrew and Arabic
    const rtlLanguages = ['he', 'ar'];
    if(i18n.global && i18n.global.locale && rtlLanguages.includes(i18n.global.locale)) {
      commit('SET_DIRECTION', 'rtl')

    } else {
      commit('SET_DIRECTION', 'ltr')
    }    

    // Apply saved direction if it exists
    if (state.direction) {
      document.getElementsByTagName("html")[0].setAttribute("dir", state.direction);
    }
    
    // Apply saved mode (light/dark) if needed
    if (state.mode) {
      document.documentElement.setAttribute('data-bs-theme', state.mode);
    }
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
  },

  changeLeftSidebarType({ commit }, { leftSidebarType }) {
    commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
  },

  changeLoaderValue({ commit }, { loader }) {
    commit('LOADER', loader)
  },

  changeLayoutMode({ commit }, { mode }) {
    commit("CHANGE_MODE", mode);
  },

  setLanguage({ commit }, { language }) {
    commit("SET_LANGUAGE", language);
  },

  setDirection({ commit }, { direction }) {
    commit("SET_DIRECTION", direction);
  }
}
